import { ButtonVariantEnum } from '../Buttons/types';

export enum DetailsPanelSize {
  Small,
  Medium,
  Large,
}

export interface IButtonOptions {
  text: string;
  visible?: boolean;
  variant?: ButtonVariantEnum;
  /** Shows spinner / loading state in confirmation step */
  loading?: boolean;
  /** Disables the left-row button (e.g. Disable while Save is in flight) */
  disabled?: boolean;
  hideConfirmation?: boolean;
  onClick?: () => void;
  confirmationMessage?: string;
}
